import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import useUserActionLog, {
  CapaActivityType,
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';
import { colorSet } from '@components/Provider';
import { MediaQuery } from '@routes/Home/HomePresenter';

export interface BlogCardProps {
  img: string;
  title: string;
  description: string;
  onClick: () => void;
}

const BlogCard: React.FC<BlogCardProps> = ({
  img,
  title,
  description,
  onClick,
  ...rest
}) => {
  const { sm } = useContext(MediaQuery);
  const { container } = useStyles({
    backgroundImg: img
  });
  const { onInsertUserActionLogOne } = useUserActionLog();

  return (
    <>
      <Box
        className={container}
        onClick={() => {
          onInsertUserActionLogOne(
            Enum_Action_Button_Enum.Landing_MANUFACTURING_KNOWLEDGE_BLOG_CARD,
            CapaActivityType.ButtonClick
          );
          onClick();
        }}
      >
        <Box className="content">
          <CustomizedTypography
            variant={sm ? 'body1' : 'h3'}
            fontWeight="500"
            gutterBottoms={9}
            className="title"
          >
            {title}
          </CustomizedTypography>
          <CustomizedTypography className="description" color="textSecondary">
            {description}
          </CustomizedTypography>
        </Box>
        <img src={img} alt="blog img" />
      </Box>
    </>
  );
};

export default BlogCard;

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '16px',
    maxWidth: 960,
    minHeight: 148,
    '& .content': {
      padding: '39px 0',
      '& h3': {
        transition: '0.2s ease-in-out',
        fontSize: '24px'
      },
      '& .title': {
        wordBreak: 'break-all'
      }
    },
    '& .description': {
      fontSize: '18px'
    },
    '& img': {
      width: 172,
      height: 120,
      borderRadius: '16px',
      margin: '14px 0'
    },
    '&:hover': {
      cursor: 'pointer',
      '& h3': {
        color: colorSet.primary500
      }
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 114,
      '& .content': {
        width: 'calc(100vw - 146px)',
        padding: '22px 0'
      },
      '& .description': {
        boxSizing: 'border-box',
        width: '100%',
        fontSize: '13px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      '& img': {
        display: 'block',
        width: 98,
        height: 74,
        margin: '23px 0'
      }
    }
  }
}));
